import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '../utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      component: () => import('../views/Login.vue'),
      meta: { public: true }
    },
    {
      path: '/',
      component: () => import('../layout/AdminLayout.vue'),
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '经营看板' } },
        { path: 'stores', name: 'Stores', component: () => import('../views/store/StoreList.vue'), meta: { title: '门店管理' } },
        { path: 'devices', name: 'Devices', component: () => import('../views/device/DeviceList.vue'), meta: { title: '设备管理' } },
        { path: 'categories', name: 'Categories', component: () => import('../views/category/CategoryList.vue'), meta: { title: '分类管理' } },
        { path: 'products', name: 'Products', component: () => import('../views/product/ProductList.vue'), meta: { title: '商品管理' } },
        { path: 'member-cards', name: 'MemberCards', component: () => import('../views/member-card/MemberCardList.vue'), meta: { title: '会员卡管理' } },
        { path: 'member-redeem-codes', name: 'MemberRedeemCodes', component: () => import('../views/member/RedeemCodeList.vue'), meta: { title: '会员卡密管理' } },
        { path: 'member-records', name: 'MemberRecords', component: () => import('../views/member/MemberRecordList.vue'), meta: { title: '会员开通记录' } },
        { path: 'customers', name: 'Customers', component: () => import('../views/customer/CustomerList.vue'), meta: { title: '用户管理' } },
        { path: 'workers', name: 'Workers', component: () => import('../views/worker/WorkerList.vue'), meta: { title: '工人管理' } },
        { path: 'notices', name: 'Notices', component: () => import('../views/notice/NoticeList.vue'), meta: { title: '通知公告管理' } },
        { path: 'banners', name: 'Banners', component: () => import('../views/banner/BannerList.vue'), meta: { title: '轮播图管理' } },
        { path: 'orders', name: 'Orders', component: () => import('../views/order/OrderList.vue'), meta: { title: '订单管理' } },
        { path: 'refunds', name: 'Refunds', component: () => import('../views/refund/RefundList.vue'), meta: { title: '退款审核' } },
        { path: 'statistics', name: 'Statistics', component: () => import('../views/statistics/StatisticsView.vue'), meta: { title: '消费统计' } },
        { path: 'worker-stats', name: 'WorkerStats', component: () => import('../views/statistics/WorkerStatsView.vue'), meta: { title: '工人报表' } },
        { path: 'store-report', name: 'StoreReport', component: () => import('../views/statistics/StoreReportView.vue'), meta: { title: '门店报表' } },
        { path: 'admin-users', name: 'AdminUsers', component: () => import('../views/system/AdminUserList.vue'), meta: { title: '管理员管理' } },
        { path: 'system-settings', name: 'SystemSettings', component: () => import('../views/system/SystemSettings.vue'), meta: { title: '系统设置' } },
        { path: 'reviews', name: 'ReviewList', component: () => import('../views/review/ReviewList.vue'), meta: { title: '评论管理' } },
        { path: 'service-terms', name: 'ServiceTerms', component: () => import('../views/content/ServiceTerms.vue'), meta: { title: '服务条款' } },
        { path: 'help-items', name: 'HelpItems', component: () => import('../views/content/HelpItems.vue'), meta: { title: '使用帮助' } },
        { path: 'service-standard', name: 'ServiceStandard', component: () => import('../views/content/ServiceStandard.vue'), meta: { title: '洗车服务标准' } },
        { path: 'car-knowledge-list', name: 'CarKnowledgeList', component: () => import('../views/content/CarKnowledge.vue'), meta: { title: '加入会员享受优惠' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next()
    return
  }
  if (!getToken()) {
    next('/login')
    return
  }
  next()
})

export default router
